import { Component, componentMixin } from '@resn/gozer-core/component';
import DomComponentMixin from '@resn/gozer-core-mixins/dom-component';
import { html } from '@resn/gozer-core';
import { COLORS } from 'core/constants';
import './index.scss';
import gsap from 'gsap/gsap-core';

const template = ({ props }) => html`
    <div class="wipe" ?visible=${props.v}>
        <div class="wipe__inner" data-ui="inner">
            <div class="wipe__shape"></div>
            <div class="wipe__bottom" data-ui="bottom"></div>
        </div>
    </div>
`;

@componentMixin(DomComponentMixin)
class Wipe extends Component {
    options = {
        template,
        color: COLORS.BLUE,
    };

    props = {
        v: false,
    };

    propsMotion = {
        openInnerDelay: 0.3,
    };

    async onSetup() {
        this.el.style.setProperty('--wipe-color', this.options.color);
    }

    setOpen(bool, { firstTrigger }) {
        if (firstTrigger) return;
        if (this.tlOpen) this.tlOpen.kill();
        this.tlOpen = this.getAnimation(bool);
    }

    setV(bool, { firstTrigger }) {
        if (firstTrigger) return;
        this.options.handlerV ? this.options.handlerV(bool) : null;
    }

    getAnimation(open = true, yFrom = '-100%') {
        const { openInnerDelay } = this.propsMotion;
        this.props.v = true;
        const tl = gsap.timeline({
            onComplete: () => (this.props.v = false),
        });
        if (open)
            tl.fromTo(this.el, { y: yFrom }, { y: '0', duration: 1.6, ease: 'power3.out' }, 0).fromTo(
                this.ui.inner,
                { y: 0 },
                { y: '100%', duration: 2.3, ease: 'power3.out' },
                openInnerDelay,
            );
        else
            tl.fromTo(this.el, { y: yFrom }, { y: '0', duration: 0.5, ease: 'power1.out' }, 0).fromTo(
                this.ui.inner,
                { y: 0 },
                { y: '100%', duration: 1.6, ease: 'power3.out' },
                0.5,
            );
        return tl;
    }
}

export default Wipe;
